const digitalFormsBaseUrl = 'DigitalForms';

export const getPANFunds = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/PANFunds/${assistanceProgramId}`);
}

export const getPANFundMedications = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/FoundationFundMedications/${assistanceProgramId}`);
}

const PANLivingInUSSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Does Patient Live in US', value, 'Patient must live and receive treatment in the United States in order to be eligible for the program.');
    }
}

const PANInsuranceCoverageSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Insurance Does Patient Have Insurance', value, 'Patient must have insurance coverage in order to be eligible for the program.');
    }
}

const PANNumberOfPeopleInHousehold = (value, ctx) => {
    const householdField = 'Income Number of People in Household';
    const field = ctx.getFieldDef(householdField);

    if (field && (parseInt(value) === 0 || parseInt(value) === 9)) {
        ctx.specialRuleChangeData(householdField, value, 'Household Size must be between the range of 1-8');
    }
}

const PANEmptyFundIfInsuranceChangesSpecialRule = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types PAN';
    const field = ctx.getFieldDef(primaryInsuranceField);
    if (field) {
        ctx.specialRuleChangeData('PAN Fund Selection', undefined);
    }
    PANMakeInsuranceFieldsReqIfMultiple(value, ctx);
}

const PANMakeInsuranceFieldsReqIfMultiple = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types PAN';
    //if length = 2 make secondary fields required, mark has secondary insurance yes
    //if length > 2 make secondary and tertiary fields req, mark has secondary and tertiary yes
    const numOfInsSelected = ctx.formData[primaryInsuranceField].length;
    if (numOfInsSelected == 1) {
        ctx.specialRuleChangeData('Insurance Does Patient Have Secondary Medical Insurance', 'No', '');
        ctx.specialRuleChangeData('Insurance Does Patient Have Tertiary Medical Insurance', 'No', '');
        ctx.specialRulePerformAction("readwrite", ['Insurance Does Patient Have Secondary Medical Insurance']);
        ctx.specialRulePerformAction("readonly", ['Insurance Does Patient Have Tertiary Medical Insurance']);
    }
    else if (numOfInsSelected == 2) {
        ctx.specialRuleChangeData('Insurance Does Patient Have Secondary Medical Insurance', 'Yes', '');
        ctx.specialRuleChangeData('Insurance Does Patient Have Tertiary Medical Insurance', 'No', '');

        ctx.specialRulePerformAction("readonly", ['Insurance Does Patient Have Secondary Medical Insurance']);
        ctx.specialRulePerformAction("readwrite", ['Insurance Does Patient Have Tertiary Medical Insurance']);
    }
    else if (numOfInsSelected > 2) {

        ctx.specialRuleChangeData('Insurance Does Patient Have Secondary Medical Insurance', 'Yes', '');
        ctx.specialRuleChangeData('Insurance Does Patient Have Tertiary Medical Insurance', 'Yes', '');
        ctx.specialRulePerformAction("readonly", ['Insurance Does Patient Have Tertiary Medical Insurance']);
    }
}

export const PANRacePreferNotToAnswerSpecialRule = (value, ctx, previousValue) => {
    const raceField = 'Patient Race';
    const noAnswer = 'Prefer not to answer';

    if (value === null) return;

    //if clicking prefer not to answer, uncheck all other selections
    if (value?.includes(noAnswer) && !previousValue?.includes(noAnswer)) {
        ctx.formData[raceField] = [noAnswer];
        ctx.warnings[raceField] = null;
    }
    //if checking more than 1 race but prefer not to answer is already checked, uncheck prefer not to answer
    else if (value.includes(noAnswer) && value.length > 1) {
        ctx.formData[raceField] = value.filter(item => item !== noAnswer);
        ctx.warnings[raceField] = null;
    }
}


export const PANInsuranceFieldsAllowedCharactersSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9-]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number',
    'Insurance Secondary Medical Insurance ID_Policy Number', 'Insurance Secondary Medical Insurance Group Number',
    'TertiaryInsurancePolicyNumber', 'TertiaryInsuranceGroupNumber'];
    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const PANNameFieldsAllowedCharactersSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z ,.'-]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Name First', 'Patient Name Middle', 'Patient Name Last', 'First Name Contact',
    'Middle Name Contact', 'Last Name Contact'];
    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const PANAddressFieldsAllowedCharactersSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 \-\']/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Address 1', 'Patient Address 2'];
    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal. (Hyphens and apostrophes are allowed)');
        });
    }
}

export const PANSecondaryInsuranceWithOneType = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types PAN';
    const numOfInsSelected = ctx.formData[primaryInsuranceField].length;
    //one insurance type selected and have secondary insurance is Yes
    //allow for has tertiary ins to be editable
    if (value == "Yes" && numOfInsSelected == 1) {
        ctx.specialRulePerformAction("readwrite", ['Insurance Does Patient Have Tertiary Medical Insurance']);
    }

    //one insurance type selected and have secondary insurance is No
    //mark has tertiary insurance as no
    if (value == "No" && numOfInsSelected == 1) {
        ctx.specialRuleChangeData('Insurance Does Patient Have Tertiary Medical Insurance', 'No', '');
        ctx.specialRulePerformAction("readonly", ['Insurance Does Patient Have Tertiary Medical Insurance']);
    }
}

function GetFieldsToCheck(ctx, value, arrToCheckAgainst) {
    const formData = Object.keys(ctx.formData).map(function (key) {
        return [key, ctx.formData[key]];
    })
    var arr = [];
    for (var i = 0; i < formData.length; i++) {
        let dataKey = formData[i][0];
        let dataValue = formData[i][1];
        if (dataValue === value) {
            arr.push(dataKey);
        }
    }
    const intersection = arr.filter(element => arrToCheckAgainst.includes(element));
    return intersection;
}

export const createPANRules = (meta, ctx) => {
    ctx.createSpecialRule('Insurance Does Patient Have Secondary Medical Insurance', PANSecondaryInsuranceWithOneType);
    ctx.createSpecialRule('Does Patient Live in US', PANLivingInUSSpecialRule);
    ctx.createSpecialRule('Insurance Does Patient Have Insurance', PANInsuranceCoverageSpecialRule);
    ctx.createSpecialRule('Insurance Patient Insurance Types PAN', PANEmptyFundIfInsuranceChangesSpecialRule);
    ctx.createSpecialRule('Patient Race', PANRacePreferNotToAnswerSpecialRule);
    ctx.createSpecialRule('Income Number of People in Household', PANNumberOfPeopleInHousehold);
    const insuranceRuleFields = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number',
        'Insurance Secondary Medical Insurance ID_Policy Number', 'Insurance Secondary Medical Insurance Group Number',
        'TertiaryInsurancePolicyNumber', 'TertiaryInsuranceGroupNumber'];
    insuranceRuleFields.forEach(field => {
        ctx.createSpecialRule(field, PANInsuranceFieldsAllowedCharactersSpecialRule);
        PANInsuranceFieldsAllowedCharactersSpecialRule(ctx.formData[field], ctx);
    });

    const nameRuleFields = ['First', 'Middle', 'Last'];
    nameRuleFields.forEach(field => {
        ctx.createSpecialRule('Patient Name ' + field, PANNameFieldsAllowedCharactersSpecialRule);
        ctx.createSpecialRule(field + ' Name Contact', PANNameFieldsAllowedCharactersSpecialRule);
        PANNameFieldsAllowedCharactersSpecialRule(ctx.formData['Patient Name ' + field], ctx);
        PANNameFieldsAllowedCharactersSpecialRule(ctx.formData[field + ' Name Contact'], ctx);
    });

    const addressRuleFields = ['Patient Address 1', 'Patient Address 2'];
    addressRuleFields.forEach(field => {
        ctx.createSpecialRule(field, PANAddressFieldsAllowedCharactersSpecialRule);
        PANAddressFieldsAllowedCharactersSpecialRule(ctx.formData[field], ctx);
    });

    PANLivingInUSSpecialRule(ctx.formData['Does Patient Live in US'], ctx);
    PANInsuranceCoverageSpecialRule(ctx.formData['Insurance Does Patient Have Insurance'], ctx);
    PANEmptyFundIfInsuranceChangesSpecialRule(ctx.formData['Insurance Patient Insurance Types PAN'], ctx);
    PANSecondaryInsuranceWithOneType(ctx.formData['Insurance Does Patient Have Secondary Medical Insurance'], ctx);
    PANNumberOfPeopleInHousehold(ctx.formData['Income Number of People in Household'], ctx)
}